import * as React from 'react';
import styled from 'styled-components';
import MuiDialog, { DialogProps as MuiDialogProps } from '@material-ui/core/Dialog';

const StyledDialog = styled(MuiDialog)``;

export type DSDialogProps = MuiDialogProps;
export const DSDialog: React.FC<DSDialogProps> = props => <StyledDialog {...props} />;
DSDialog.displayName = 'DSDialog';
